// Keys under which the theme is stored through the user preferences API.
export const THEME_PRIMARY_COLOR_KEY = 'theme.primaryColor'
export const THEME_SCHEME_KEY = 'theme.scheme'

// Profile name `{ firstName, lastName }`. Absent until the user saves it.
export const FULL_NAME_KEY = 'fullName'

// Staff-only switch for the staging data provider. Read on the server, so the page
// mints the matching Embeddable token.
export const STAGING_DATA_PROVIDER_KEY = 'dashboard.stagingDataProvider'
